import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "chevron"]

  connect() {
    this.isOpen = false
    // Close dropdown when clicking outside
    document.addEventListener("click", this.closeOnOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick.bind(this))
  }

  toggle(event) {
    event.stopPropagation()
    
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Close all other open dropdowns first
    document.querySelectorAll('[data-controller="dropdown"]').forEach(dropdown => {
      if (dropdown !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(dropdown, 'dropdown')
        if (controller && controller.isOpen) {
          controller.close()
        }
      }
    })
    
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("hidden")
      this.positionMenu()
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = "rotate(180deg)"
    }
    this.isOpen = true
  }

  positionMenu() {
    if (!this.hasMenuTarget) return

    const menu = this.menuTarget
    const button = this.element.querySelector('button')
    const menuRect = menu.getBoundingClientRect()
    const buttonRect = button.getBoundingClientRect()
    
    // Reset classes
    menu.classList.remove('bottom-full', 'mb-2', 'mt-2', 'top-full')
    
    // Check if there's enough space below
    const spaceBelow = window.innerHeight - buttonRect.bottom
    const spaceAbove = buttonRect.top
    
    if (spaceBelow < menuRect.height && spaceAbove > menuRect.height) {
      // Position above
      menu.classList.add('bottom-full', 'mb-2')
    } else {
      // Position below (default)
      menu.classList.remove('bottom-full', 'mb-2')
      menu.classList.add('mt-2')
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = "rotate(0deg)"
    }
    this.isOpen = false
  }

  hide() {
    // Alias for close() method to support both naming conventions
    this.close()
  }

  closeOnOutsideClick(event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this.close()
    }
  }
}
